<template>
    <section class="sideBar"
        v-if="selectedTab === '' || !isMobile">
        <div class="title">
            <Icon class="icon"
                icon="settings" size="l"/>
            <Heading size="xl">
                {{ content.settings }}
            </Heading>
        </div>
        <nav>
            <div :class="['navItem', { selectedTab: selectedTab === index }]"
                v-for="(item, index) in navigation"
                :key="index"
                @click="$emit('changeSelectedTab', item, index)">
                {{ item.tabName }}
                <Icon
                    icon="chevron_right"
                    appearance="inherit"/>
            </div>
            <div :class="['navItem', { selectedTab: selectedTab === 'waitlist' }]"
                v-if="permissions.isAdmin"
                @click="$emit('changeSelectedTab', { tabName: 'waitlist', tabTitle: 'Invite Users' }, 'waitlist')">
                {{ content.waitlist }}
                <Icon
                    icon="chevron_right"
                    appearance="inherit"/>
            </div>
        </nav>
    </section>
</template>

<script>
    export default {
        name: 'SideBar',
        props: {
            selectedTab: {
                type: String,
                required: true
            },
            isMobile: {
                type: Boolean,
                required: true
            },
            content: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                navigation: { }
            }
        },
        mounted() {
            this.navigation = {
                language: {
                    tabName: this.content.general,
                    tabTitle: this.content.general
                },
                timeline: {
                    tabName: this.content.timeline,
                    tabTitle: this.content.timeline
                },
                display: {
                    tabName: this.content.appearance,
                    tabTitle: this.content.appearance
                },
                privacy: {
                    tabName: this.content.security,
                    tabTitle: this.content.security
                }
            },
            this.$emit('changeSelectedTab', this.navigation.language, 'language')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .sideBar {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        min-width: 20rem;
        border-right: var(--border-grey-300);
    }

    .title {
        display: flex;
        align-items: center;
        padding: 2rem 0 2rem 0.75rem;
    }

    .h1 {
        margin: 0;
    }

    .icon {
        margin-right: 1rem;
    }

    .navigation {
        display: flex;
        flex-direction: column;
    }

    .navItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 1.5rem;
        font-family: $font-secondary;
        font-size: 1rem;
        cursor: pointer;
        transition: $transition-eio-20;

        &:hover {
            background: var(--color-grey-100);
        }

        &.selectedTab {
            background: var(--color-grey-150);
            color: var(--color-primary-500);
        }
    }

    @media all and (max-width: 640px) {

        .sideBar {
            width: 100%;
        }
    }
</style>